export const snooze = "eab";
export default {snooze};